import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      flexGrow: 1,
      backgroundColor: "#FAFAFA",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      width: "calc(100vw - 96px)",
      left: "96px",
      paddingTop: "101px",
      height: "calc(100vh - 90px)"
    },
    navText: {
      color: "#5A5A5A",
      "& > span": {
        fontWeight: 400,
        fontSize: "12px"
      },
    },
  }),
);
